import { gql } from '@apollo/client';

//returns a personIncidentSpecific
export const KNOWN_ASSOCIATES_LENGTH = gql`
  query KNOWN_ASSOCIATES_LENGTH($personId: ID!, $originatorId: ID!){
    knownAssociates(personId: $personId, originatorId: $originatorId) {
      id
    }
  }
`;